import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExamsComponent } from './exams.component';
import { RouterModule } from '@angular/router';
import { ExamsService } from './exams.service';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';


const routes = [
  {
    path: "exames",
    component: ExamsComponent,
  },
];

@NgModule({
  declarations: [ExamsComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    TranslateModule,
    MatButtonModule,
    FuseSharedModule,
    MatTableModule,
    MatCardModule,
    MatIconModule,
    MatPaginatorModule,
    MatTabsModule
  ],
  providers: [ExamsService],
  exports: [ExamsComponent],
})
export class ExamsModule { }
